module.exports = __webpack_public_path__ + "media/images/del_fantasy_logo-85ed969329a81e0fb973fcf3eab0c64c.png";